import { NexaBlack } from '@/styles/fonts'

type ReactionItem = {
    title: string
    url: string
}

type DropdownContentProps = {
    title: string
    items: ReactionItem[]
    /** Categories uses a different grid than reactions. */
    isCategories?: boolean
}

// The grid shape is keyed on this flag rather than on the title, which is
// translated -- matching English text here would silently reshape the menu in
// every other language.
const DropdownContent = ({ title, items, isCategories = false }: DropdownContentProps) => {
    const gridCols = isCategories ? 'grid-cols-5' : 'grid-cols-6'
    const gridRows = isCategories ? 'grid-rows-6' : 'grid-rows-7'

    return (
        <div className={`h-full w-full pt-[22px] pr-6 pb-6 pl-10`}>
            <h2 className={`text-[28px] font-bold text-white ${NexaBlack.className}`}>{title}</h2>
            <div
                className={`mt-[14px] mb-[22px] w-[calc(100%-24px)] border-[0.5px] border-t border-white opacity-30`}
            />
            <div
                className={`grid ${gridCols} ${gridRows} grid-flow-col gap-x-4 gap-y-3 text-white has-[a:hover]:[&_a:not(:hover)]:opacity-60 `}
            >
                {items.map((item, idx) => (
                    <a
                        key={item.title + idx}
                        href={item.url}
                        className="text-left text-base font-semibold transition-opacity duration-500"
                    >
                        {item.title}
                    </a>
                ))}
            </div>
        </div>
    )
}

export default DropdownContent
